import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { DEFAULT_LANGUAGE, LANGUAGES } from "@/i18n/config";

import en from "@/i18n/locales/en.json";
import es from "@/i18n/locales/es.json";
import fr from "@/i18n/locales/fr.json";
import de from "@/i18n/locales/de.json";
import pt from "@/i18n/locales/pt.json";
import it from "@/i18n/locales/it.json";
import hi from "@/i18n/locales/hi.json";
import ar from "@/i18n/locales/ar.json";
import ur from "@/i18n/locales/ur.json";
import zh from "@/i18n/locales/zh.json";
import ja from "@/i18n/locales/ja.json";
import tr from "@/i18n/locales/tr.json";
import ru from "@/i18n/locales/ru.json";

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
  pt: { translation: pt },
  it: { translation: it },
  hi: { translation: hi },
  ar: { translation: ar },
  ur: { translation: ur },
  zh: { translation: zh },
  ja: { translation: ja },
  tr: { translation: tr },
  ru: { translation: ru },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: LANGUAGES.map(l => l.code),
    load: "languageOnly",           // treat en-US as "en", ar-EG as "ar", etc.
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      // We drive language changes ourselves per scope; detector runs on first
      // load only to pick a sensible initial value from the browser.
      order: ["navigator", "htmlTag"],
      caches: [],
    },
    returnEmptyString: false,
  });

export default i18n;
